import modelBaseV2 from "../model-base-v2.model";

const BatchJobManagementErrorReportModel = {
    searchBatchJobManagementErrorReport: (params) => {
        const qs = modelBaseV2.toQueryString(params)
        return modelBaseV2.get(`/api/intf-edi/batch/errorlog?${qs}`);

    }
}
export default BatchJobManagementErrorReportModel